import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {Injectable, signal} from '@angular/core';
import {Template} from '@pdfme/common';

export interface CertificateTemplateItem {
  id: number;
  name: string;
  template: Template;
}

@Injectable()
export class CertificateTemplateService {
  certificateEnabled = signal(false);

  constructor(private http: HttpClient, private api: AppConfig) {}

  saveTemplate(body: object) {
    return this.http.post(this.api.baseUrl + '/certificateTemplate/saveTemplate', body, this.api.jsonTokenHeaders);
  }

  templates(organizationId?: number) {
    const query = organizationId != null ? '?organizationId=' + organizationId : '';
    return this.http.get<CertificateTemplateItem[]>(this.api.baseUrl + '/certificateTemplate/templates' + query, this.api.jsonTokenHeaders);
  }

  template(id: number) {
    return this.http.get(this.api.baseUrl + '/certificateTemplate/template?id=' + id, this.api.jsonTokenHeaders);
  }

  deleteTemplate(id: number) {
    return this.http.delete(this.api.baseUrl + '/certificateTemplate/deleteTemplate?id=' + id, this.api.jsonTokenHeaders);
  }

  sendEventCertificate(userId: number, eventId: number) {
    return this.http.post(this.api.baseUrl + '/certificate/sendEventCertificate', {userId, eventId}, this.api.jsonTokenHeaders);
  }

  sendTaskCertificate(frontUserId: number, taskId: number) {
    return this.http.post(this.api.baseUrl + '/certificate/sendTaskCertificate', {frontUserId, taskId}, this.api.jsonTokenHeaders);
  }

  createElearningCertificate(frontUserId: number, elearningId: number) {
    return this.http.post(this.api.baseUrl + '/certificate/createElearningCertificate', {frontUserId, elearningId}, this.api.jsonTokenHeaders);
  }

  createLearningPathsCertificate(frontUserId: number, learningPathsId: number) {
    return this.http.post(this.api.baseUrl + '/certificate/createLearningPathsCertificate', {frontUserId, learningPathsId}, this.api.jsonTokenHeaders);
  }

  getImage(id: number) {
    return this.http.get(this.api.baseUrl + '/certificateTemplate/getImage?id=' + id, {
      ...this.api.jsonTokenHeaders,
      responseType: 'text',
    });
  }

  uploadImage(file: File, connectedId?: number, type?: string) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('connectedId', connectedId?.toString() ?? '');
    formData.append('type', type ?? '');
    return this.http.post<{id: string}>(this.api.baseUrl + '/certificateTemplate/uploadImage', formData, this.api.formDataHeaders);
  }
}
